import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Box, Container, TextField, Typography, Link } from "@mui/material";
import { useDispatch } from "react-redux";
import { login_action } from "../../../redux/auth/auth.actions";
import { useSelector } from "react-redux";
import { get_auth_process_states, get_auth_status } from "../../../redux/auth/auth.selectors";
// import ReCAPTCHA from "react-google-recaptcha";
import { LoadingButton } from "@mui/lab";

const LoginPage = () => {
  const dispatch = useDispatch();

  const isAuth = useSelector(get_auth_status);
  const { auth_process_loading } = useSelector(get_auth_process_states);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth) {
      navigate("/select-plant");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [captcha_verified,
    // set_captcha_verified
  ] = useState(true);
  // function onChange(value) {
  //   // console.log("Captcha value:", value);
  //   if (value) set_captcha_verified(true);
  //   else set_captcha_verified(false);
  // }

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your login logic here
    const username = email;
    dispatch(
      login_action({
        email,
        password,
        username,
      }),
    );
  };

  return (
    <Container maxWidth="sm">
      <div className="flex justify-center items-center">
        <img
          className="h-[10rem] mr-4"
          src="/ripikremovedbg.png"
          alt="ripik.ai"
        />
      </div>
      <Box
        sx={{
          marginTop: "100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Login
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "300px",
          }}
        >
          <TextField
            label="Email/Username"
            variant="outlined"
            autoComplete="email"
            fullWidth
            required
            onChange={(e) => {
              const text = (e.target.value).toLowerCase().trim();
              setEmail(text);
            }}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            autoComplete="current-password"
            fullWidth
            required
            onChange={(e) => {
              const text = (e.target.value);
              setPassword(text);
            }}
          />
          <Typography variant="body2" align="right" m={0}>
            <Link component={RouterLink} to="/forgot-password">
              Forgot Password?
            </Link>
          </Typography>
          {/* <ReCAPTCHA
            sitekey={(() => process.env.REACT_APP_CAPTCHA_SITE_KEY)()} onChange={onChange}
          /> */}
          <LoadingButton
            loading={auth_process_loading}
            variant="contained"
            type="submit"
            color="primary"
            fullWidth
            disabled={!email || !password || password?.length < 8 || !captcha_verified}
            sx={{ color: "white" }}
          >
            Login
          </LoadingButton>
        </Box>
        {/* <Typography variant="body2" align="center" mt={2}>
          Don't have an account?{" "}
          <Link component={RouterLink} to="/signup">
            Signup
          </Link>
        </Typography> */}
      </Box>
    </Container>
  );
};

export default LoginPage;
